import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { DepartmentStateType, DepartmentTreeType } from '@redux/types'
import { DepartmentType } from '@schemas'

// initial state
const initialState: DepartmentStateType = {
	// trigger
	triggerGetDepartmentList: false,

	// department
	departmentList: [],
	departmentTree: [],
}

const slice = createSlice({
	name: 'department',
	initialState,
	reducers: {
		// trigger
		TRIGGER_GET_DEPARTMENT_LIST: (
			state: DepartmentStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerGetDepartmentList = action.payload
		},

		// department
		DEPARTMENT_LIST: (
			state: DepartmentStateType,
			action: PayloadAction<DepartmentType[]>,
		) => {
			state.departmentList = action.payload
		},
		DEPARTMENT_TREE: (
			state: DepartmentStateType,
			action: PayloadAction<DepartmentTreeType[]>,
		) => {
			state.departmentTree = action.payload
		},
	},
})

export const departmentActions = slice.actions
export default slice.reducer
